import React, { useMemo, useState } from "react";
import { Tooltip, IconButton, withStyles } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { MONTSERRAT } from "../../../../constants/fontCss";
import {
    ARCHIVED,
    COMMERCIALLY_FOLLOWED_UP_STATUS, COMPLETE_REPAIR, GO_DOC, MAYBE,
    REPAIRED, REPAIRING,
    TO_BE_INVOICED_STATUS,
    TO_SCHEDULE_STATUS,
    WAITING_FOR_REPLY,
    WAITING_VIDEOS_PHOTOS,
    XS
} from "../../../../constants/constants";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { customRenderShowBtnAction } from "../constantRequestPage";
import goFilterIcon from "../../../../images/request/Groupe 9099.svg";
import archiveIcon from "../../../../images/request/Groupe 9100.svg";
import allIcon from "../../../../images/request/Groupe 9130.svg";

const styles = (theme) => ({
    threeDotBtn: {
        borderRadius: 0,
        "&:hover": {
            background: "rgba(91, 94, 255, 0.08) !important",
            top: -4,
            transition: '0.2s ease'
        }
    },
    popoverEditStatus: {
        background: '#fff',
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
        borderRadius: 10,
        minWidth: 200,
        maxWidth: 400,
        [theme.breakpoints.down(XS)]: {
            maxWidth: 'calc(100vw - 20px)'
        }
    },
    headerEditStatus: {
        background: '#001529',
        boxShadow: '0px 0px 20px rgba(0, 0, 254, 0.05)',
        borderRadius: '10px 10px 0px 0px',
        color: '#fff',
        fontWeight: 600,
        padding: '0.5rem',
    },
    contentEditStatusWrapper: {
        padding: '0.5rem',
        width: '100%',
        '& .btnActionEdit': {
            margin: '5px 10px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            width: 'fit-content',
            minWidth: 170,
            maxWidth: '100%',
            padding: '4px 16px',
            borderRadius: 8,
            background: 'transparent',
            border: '1px solid transparent',
            '&:hover':{
                background: '#ebf2f8',
            },
            '&.activeChooseBtn': {
                background: '#DDDDFF',
                '& div':{
                    fontWeight: 600
                }
            },
            '& .iconWrapper':{
                display: 'flex',
                alignItems: 'center',
            },
            '& svg': {
                width: 20,
                '& path': {
                    fill: '##0000fe !important'
                }
            },
            '& .titleIcon': {
                paddingLeft: 8,
                color: '#0000fe',
                textTransform: 'uppercase',
                lineHeight: 1.1,
                fontWeight: 500,
            }
        },
        '& .btnAction':{
            padding: 10,
            display: 'flex',
            justifyContent: 'center'
        }
    },
    btnResponse: {
        background: '#0000FF !important',
        borderRadius: 10,
        '& .MuiButton-label': {
            fontFamily: MONTSERRAT,
            fontWeight: 700,
            fontSize: '0.875rem'
        }
    }
});
// Function to check if the device is mobile or tablet
const isTouchDevice = () => {
    try {
        return (
            "ontouchstart" in window ||
            navigator.maxTouchPoints > 0 ||
            navigator.userAgent.match(/(Android|iPhone|iPad|iPod|Windows Phone|Mobile|Tablet)/i)
          );
    } catch(e){
        return false
    }
};
const TransparentTooltip = withStyles({
    tooltip: {
      backgroundColor: "transparent", // Nền trong suốt
      boxShadow: "none",
      padding: 0, // Loại bỏ padding mặc định
    },
    arrow: {
      color: "transparent", // Ẩn mũi tên
    },
  })(Tooltip);
const ChangeStatusTooltip = (props) => {
    const {
        classes, formValuePopover, t,
        handleSave
    } = props;
    const [open, setOpen] = useState(false);
    const isMobileOrTablet = useMemo(isTouchDevice, []);
    const currentStatus =  ((formValuePopover?.statusFilterCode) ?? "");
    const onChangeStatus = (status) => {
        handleSave && handleSave(status)
    }
  return (
    <TransparentTooltip
      title={
        <div className={classes.popoverEditStatus}>
                <div className={`${classes.headerEditStatus} headerEditStatus`}>
                    {t("request.list.id")}: {formValuePopover.id}
                </div>
                <div className={`${classes.contentEditStatusWrapper} contentEditStatusWrapper`}>
                    {currentStatus !== WAITING_VIDEOS_PHOTOS && customRenderShowBtnAction({
                        className: `btnActionEdit ${currentStatus === WAITING_VIDEOS_PHOTOS ? "activeChooseBtn" : ""}`,
                        onClick: () => onChangeStatus(WAITING_VIDEOS_PHOTOS),
                        icon: goFilterIcon,
                        title: t("request.status.WAITING_VIDEOS_PHOTOS")
                    })}
                    {currentStatus !== WAITING_FOR_REPLY && customRenderShowBtnAction({
                        className: `btnActionEdit ${currentStatus === WAITING_FOR_REPLY ? "activeChooseBtn" : ""}`,
                        onClick: () => onChangeStatus(WAITING_FOR_REPLY),
                        icon: goFilterIcon,
                        title: t("request.status.TO_PROCESS")
                    })}
                    {currentStatus !== COMMERCIALLY_FOLLOWED_UP_STATUS && customRenderShowBtnAction({
                        className: `btnActionEdit ${currentStatus === COMMERCIALLY_FOLLOWED_UP_STATUS ? "activeChooseBtn" : ""}`,
                        onClick: () => onChangeStatus(COMMERCIALLY_FOLLOWED_UP_STATUS),
                        icon: goFilterIcon,
                        title: t("request.status.COMMERCIALLY_FOLLOWED_UP")
                    })}
                    {currentStatus !== TO_SCHEDULE_STATUS && customRenderShowBtnAction({
                        className: `btnActionEdit ${currentStatus === TO_SCHEDULE_STATUS ? "activeChooseBtn" : ""}`,
                        onClick: () => onChangeStatus(TO_SCHEDULE_STATUS),
                        icon: goFilterIcon,
                        title: t("request.status.TO_SCHEDULE")
                    })}
                    {/*{(formValuePopover.archivedByAdmin || formValuePopover.repeatAt) && customRenderShowBtnAction({*/}
                    {/*    className: `btnActionEdit ${value === UNARCHIVED_AND_NOT_REPEAT ? "activeChooseBtn" : ""}`,*/}
                    {/*    onClick: () => setValue(UNARCHIVED_AND_NOT_REPEAT),*/}
                    {/*    icon: goFilterIcon,*/}
                    {/*    title: t("request.status.unarchivedAndNotRepeat")*/}
                    {/*})}*/}
                    { !!(currentStatus !== TO_BE_INVOICED_STATUS) && customRenderShowBtnAction({
                        className: `btnActionEdit ${currentStatus === TO_BE_INVOICED_STATUS ? "activeChooseBtn" : ""}`,
                        onClick: () => onChangeStatus(TO_BE_INVOICED_STATUS),
                        icon: allIcon,
                        title: t("request.status.TO_BE_INVOICED")
                    })}
                    { currentStatus !== ARCHIVED  && customRenderShowBtnAction({
                        className: `btnActionEdit ${currentStatus === ARCHIVED ? "activeChooseBtn" : ""}`,
                        onClick: () => onChangeStatus(ARCHIVED),
                        icon: archiveIcon,
                        title: t("request.status.archived")
                    })}
                </div>
            </div>
      }
      placement="bottom-start"
      interactive
      disableTouchListener={isMobileOrTablet}
      disableFocusListener={isMobileOrTablet}
      open={isMobileOrTablet ? open : undefined}
      onClose={() => setOpen(false)}
    >
      <IconButton className={classes.threeDotBtn}
      onClick={() => {
        if (isMobileOrTablet) {
        setOpen((prev) => !prev);
        }
      }}
      >
        <MoreVertIcon style={{
             color: "rgb(20, 20, 255)",
        }}/>
      </IconButton>
    </TransparentTooltip>
  );
};


export default compose(withStyles(styles), withTranslation())(ChangeStatusTooltip);
